//Defer Video Loading

$(document).ready(function () {
  var videoinit = false;
  const scrollPos = $(document).scrollTop();
  const allvideos = document.querySelectorAll("video");
  const autoplayvids = document.querySelectorAll(".autoplayvideo");

  $("body").on("click touchstart", function () {
    if (videoinit === false) {
      playallvideos();
    }
  });

  $(window).scroll(function () {
    if (videoinit === false) {
      playallvideos();
    }
  });

  function playallvideos() {
    allvideos.forEach((vid) => {
      if (vid.playing) {
      } else {
        vid.play();
      }
    });
    videoinit = true; 
  }

  function loadautoplay() {
    autoplayvids.forEach((vid) => {
      if (vid.playing) {
      } else {
        vid.play();
      }
    });
  }

  window.addEventListener("load", (event) => {
    loadautoplay();
  });

  if (scrollPos > 100) {
    if (videoinit === false) {
      playallvideos();
    }
  }

$('img,.project-item,.banner').bind("contextmenu",function(e){
  return false;
});
  
});

//CSS Injections
function injectcss(stylesheet) {
  if (!$(`link[href='${stylesheet}']`).length) {
    $(`<link href="${stylesheet}" rel="stylesheet">`).appendTo("head");
  }
}

//JS Injections
function injectjs(src) {
  if (!$(`script[href='${src}']`).length) {
    var tag = document.createElement("script");
    tag.async = false;
    tag.src = src;
    document.body.appendChild(tag);
  }
}


window.addEventListener('load', () => {
  quicklink.listen();
});


//Change Tab Text on When Navigated Away From

$(function() {
  var message = "Stay Focused...";
  var original;

  $(window).focus(function() {
    if (original) {
      document.title = original;
    }
  }).blur(function() {
    var title = $('title').text();
    if (title != message) {
      original = title;
    }
    document.title = message;
  });
});


// Smooth Scroll

const lenis = new Lenis({
  duration: .5
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)